import type { MinifiedTask } from '@gcv/shared';
import { TaskInternalExternal } from '@gcv/shared';

/** A task is external when it is assigned outside the bank that owns it, which is what splits the task tabs. */
export const getTaskDirection = (task: MinifiedTask): TaskInternalExternal =>
  task.assigned_org && task.assigned_org.id !== task.org_id
    ? TaskInternalExternal.EXTERNAL
    : TaskInternalExternal.INTERNAL;
